import { money } from "../../../../../../../../../../utils/numeral/money";
import { budgetSeriesName } from "../../../../../../../../common/billing-explorer/utils/addBudgetLineIntoBillingExplorerChartData";

export const generateBillingExplorerChartBudgetTooltipMarkup = (
  cost: number,
) => {
  return `
 <div style="display: flex; align-items: center; border-left: 4px solid red; padding-left: 8px; border-radius: 2px;">
        <div>
          <div style="display:flex; margin-bottom: 6px; gap:8px; justify-content: space-between;">
            <span style="font-weight: 400; font-size: 12px;">${budgetSeriesName}</span><br>
            <span style="font-weight: 500; font-size: 14px;">${money(cost)}</span>
          </div>
        </div>
    </div>
`;
};
